import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/api";

const GA_ID = process.env.REACT_APP_GA_ID;

function loadGA(id) {
  if (window.gtagLoaded || !id) return;
  window.gtagLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false });
}

export default function Tracker() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (GA_ID) loadGA(GA_ID);
  }, []);

  useEffect(() => {
    // don't track the private admin area
    if (pathname.startsWith("/admin")) return;
    track("pageview", pathname);
    if (GA_ID && window.gtag) {
      window.gtag("event", "page_view", { page_path: pathname });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
